module.exports = __webpack_public_path__ + "static/media/turkey.b6720ddf.svg";